module.exports = "/assets/1f04c7af1c06242171023879754cb785.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/5O.png
// module id = 1066
// module chunks = 0